var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLasricNull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "no_notifications",
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.681,
    height: 79.68,
    viewBox: "0 0 79.681 79.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7148",
    "data-name": "Path 7148",
    d: "M173,378.139H163a2.334,2.334,0,0,1-2.334-2.334v-20A2.334,2.334,0,0,1,163,353.467h10a2.334,2.334,0,0,1,2.334,2.334v20A2.334,2.334,0,0,1,173,378.139Z",
    transform: "translate(-135.662 -298.459)",
    fill: "#f9f3ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7149",
    "data-name": "Path 7149",
    d: "M212.8,353.467h-5v24.672h5a2.334,2.334,0,0,0,2.334-2.334v-20a2.334,2.334,0,0,0-2.334-2.338Z",
    transform: "translate(-175.461 -298.459)",
    fill: "#f2e1ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7150",
    "data-name": "Path 7150",
    d: "M49.842,128.533H14.836A14.853,14.853,0,0,0,0,143.369v22.5A2.334,2.334,0,0,0,2.334,168.2H35.005a4.669,4.669,0,0,0,4.669-4.669V143.367A10.158,10.158,0,0,1,49.839,133.2h0a2.335,2.335,0,1,0,0-4.669Z",
    transform: "translate(0 -108.53)",
    fill: "#9d00ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7151",
    "data-name": "Path 7151",
    d: "M0,256v17.5a2.334,2.334,0,0,0,2.334,2.334H35.005a4.669,4.669,0,0,0,4.669-4.669V256Z",
    transform: "translate(0 -216.16)",
    fill: "#b156ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7152",
    "data-name": "Path 7152",
    d: "M108.736,0h-10A2.334,2.334,0,0,0,96.4,2.334v10a2.334,2.334,0,0,0,2.334,2.334H106.4V34.839a2.334,2.334,0,1,0,4.669,0V2.334A2.334,2.334,0,0,0,108.736,0Z",
    transform: "translate(-81.398)",
    fill: "#6300d6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7153",
    "data-name": "Path 7153",
    d: "M239.77,128.533a14.853,14.853,0,0,0-14.836,14.836v20.169a2.334,2.334,0,0,0,2.334,2.334h25a2.334,2.334,0,0,0,2.334-2.334V143.369a14.853,14.853,0,0,0-14.832-14.836Z",
    transform: "translate(-189.929 -108.53)",
    fill: "#142d3f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7154",
    "data-name": "Path 7154",
    d: "M224.933,256v15.168a2.334,2.334,0,0,0,2.334,2.334h25a2.334,2.334,0,0,0,2.334-2.334V256Z",
    transform: "translate(-189.928 -216.16)",
    fill: "#070f15"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7155",
    "data-name": "Path 7155",
    d: "M267.274,358.136H224.933v-4.669h42.341a2.335,2.335,0,1,1,0,4.669Z",
    transform: "translate(-189.928 -298.459)",
    fill: "#6300d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLasricNull);
export default __webpack_public_path__ + "static/media/lasric_null.a2abe7cbe5a9e0f843f5f9db981c43ec.svg";
export { ForwardRef as ReactComponent };